// src/redux/tokenApi.js
import { apiSlice } from "./apiSlice";

export const tokenApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // POST /token/refresh
        refreshToken: build.mutation({
            query: (body) => ({
                url: "/token/refresh",
                method: "post",
                data: body,
            }),
        }),
        // POST /token/exchange (로그인)
        tokenExchange: build.mutation({
            query: (body) => ({
                url: "/token/exchange",
                method: "post",
                data: body,
            }),
        }),
    }),
});

export const { useRefreshTokenMutation, useTokenExchangeMutation } = tokenApi;
